<style id="custom-styles-container">
  .col{display:flex;}
  .col div{flex:1}
  a:link {
    color: black;
    background-color: transparent;
    text-decoration: underline;
  }
</style>
<div fxLayoutAlign="center start">
  <mat-card appearance="outlined" class='loginCard' style="margin-top: 50px">
    <mat-card-header>
      <mat-card-title fxLayoutAlign="end end">
        <!-- Login -->
        <img src="assets/images/logo-mwi-new.jpg" style="width: 70%;  max-height: 150px"/>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content *ngIf="!shouldShowLoader()">
      <mat-vertical-stepper [linear]="true" #stepper>
        <mat-step state="notifications" *ngIf="shouldShowNotifications()" [completed]="!loginIsDisabled">
          <ng-template matStepLabel="notifications">
            <span>Important notice</span>
          </ng-template>
          <mat-list>
            <mat-list-item
              *ngFor="let notification of notificationList"
              [innerHTML]="notification.message | noSanitize"
              style="height: auto;"
            ></mat-list-item>
          </mat-list>
        </mat-step>
        <mat-step state="login" [completed]="!loginIsDisabled">
          <ng-template matStepLabel="login">
            <span>Login</span>
          </ng-template>
          <form fxLayout="column" form="loginForm">
            <mat-form-field appearance="outline">
              <mat-label>Username</mat-label>
              <input
                matInput
                autocomplete="off"
                placeholder="Username"
                name="username"
                [formControl]="frmUsername"
              />
              <mat-icon matSuffix class='loginIcon'>fingerprint</mat-icon>
              <mat-error
                *ngIf="frmUsername.hasError('required')"
                style="color: #d32f2f"
              >
                Username is required
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Password</mat-label>
              <input
                matInput
                autocomplete="off"
                placeholder="Password"
                name="password"
                type="{{ passwordInputType }}"
                [formControl]="frmPassword"
                (keyup.enter)="onClickSumbitLogin()"
              />
              <mat-icon matSuffix (click)="onClickPasswordIcon()" class='loginIcon'
              >visibility</mat-icon
              >
              <mat-error
                *ngIf="frmPassword.hasError('required')"
                style="color: #d32f2f"
              >
                Password is required
              </mat-error>
            </mat-form-field>

            <div fxLayout="row" style="margin-top: 15px">
              <button
                mat-raised-button
                type="button"
                color="primary"
                (click)="onClickSumbitLogin()"
                [disabled]="shouldDisableLogin()"
              >
                Login
              </button>
            </div>
          </form>
        </mat-step>
        <mat-step state="forgot_password">
          <ng-template matStepLabel="forgot_password">
            <span style="color: #d32f2f">
              I forgot my password / Account locked
            </span>
          </ng-template>
          <p>
            Please provide us with the username for the account that you would
            like to reset
          </p>
          <form fxLayout="column" form="resetForm">
            <mat-form-field appearance="outline">
              <mat-label>Username</mat-label>
              <input
                matInput
                autocomplete="off"
                placeholder="Username"
                name="resetUsername"
                [formControl]="frmResetUsername"
              />
              <mat-icon matSuffix>fingerprint</mat-icon>
              <mat-error
                *ngIf="frmResetUsername.hasError('required')"
                style="color: #d32f2f"
              >
                Username is required
              </mat-error>
            </mat-form-field>

            <div fxLayout="row" style="margin-top: 15px">
              <button
                mat-raised-button
                type="button"
                color="primary"
                (click)="onClickSubmitReset()"
                [disabled]="shouldDisableReset()"
              >
                Reset password
              </button>
            </div>
          </form>
        </mat-step>
        <mat-step state="forgot_username">
          <ng-template matStepLabel="forgot_username">
            <span style="color: #d32f2f">I forgot my username</span>
          </ng-template>
        </mat-step>
        <!-- Icon overrides. -->
        <ng-template matStepperIcon="notifications">
          <mat-icon>info</mat-icon>
        </ng-template>
        <ng-template matStepperIcon="login">
          <mat-icon>lock</mat-icon>
        </ng-template>
        <ng-template matStepperIcon="forgot_password">
          <mat-icon>help</mat-icon>
        </ng-template>
        <ng-template matStepperIcon="forgot_username">
          <mat-icon>help</mat-icon>
        </ng-template>
      </mat-vertical-stepper>
      <div>
        <div class="col">
          <div class="col1" style="text-align: center">
          <span>
            <h5 style="padding-bottom: 5px; margin-bottom: 5px">
              Client contact centre
            </h5>
          </span>
            <span style="font-size: 12px; color: black">
            <a href="tel:+270126845008" style="text-decoration: none;">+27 (0)12 684 5008</a><br />
            or<br />
            <a href="tel:+270860444433" style="text-decoration: none;">0860 444 433</a> <br /><br />
            <a href="mailto:client.services@momentum.co.gg" style="text-decoration: none;">client.services@momentum.co.gg</a><br />
          </span>
          </div>
          <div class="col2" style="text-align: center">
          <span>
            <h5 style="padding-bottom: 5px; margin-bottom: 5px">
              Address
            </h5>
          </span>
            <span style="font-size: 12px; color: black">
            <b>Registered office</b><br />
            La Plaiderie House<br />
            St Peter Port<br />
            Guernsey<br />
            GY1 1WF<br />
          </span>
          </div>
        </div>
        <br />
        <div style="text-align: center">
          <span>
            <h5 style="padding-bottom: 5px; margin-bottom: 5px">
              Operating hours:
            </h5>
          </span>
          <span style="font-size: 12px; color: black">
            Mon to Fri from 08:00 – 17:00 SAST (South Africa Standard Time).<br />
            Closed on Saturdays, Sundays and Guernsey public holidays.<br />
          </span>
        </div>
        <br />
        <div style="text-align: center">
        <span style="font-size: 11px; color: black">
            <a href="{{getConfigValues('notices')}}">Important notices</a> | <a href="{{getConfigValues('terms')}}">Terms and Conditions</a>  | <a href="{{getConfigValues('privacyPolicy')}}">Privacy policy</a>  | <a href="{{getConfigValues('conflictPolicy')}}">Conflict of Interest Management Policy</a> | <a href="{{getConfigValues('complaintsProcedure')}}">Complaints Handling Procedure</a><br />
            Momentum Wealth International Limited is licensed by the Guernsey Financial Services Commission to conduct Investment Business. Momentum Wealth International Limited is an authorised Financial Services Provider pursuant to the Financial Advisory and Intermediary Services Act No. 37 of 2002 in South Africa.<br />
            A member of <a href="https://www.momentummetropolitan.co.za">Momentum Metropolitan Holdings Limited.</a><br />
            Registered address: La Plaiderie House, La Plaiderie, St Peter Port, Guernsey, Channel Islands, GY1 1WF Registered in Guernsey No. 30830.<br />
          </span>
        </div>
      </div>



    </mat-card-content>

    <mat-card-content
      fxLayout="column"
      *ngIf="shouldShowLoader()"
      fxLayoutAlign="center center"
      style="height: 240px"
    >
      <span fxFlex="100" style="padding-top: 30px; place-content: flex-start center;">
        <mat-spinner></mat-spinner>
      </span>
      <span fxFlex="100" style="place-content: flex-start center;">
        <h3>Communicating with the server...</h3>
      </span>
    </mat-card-content>
  </mat-card>
</div>
